export default "__VITE_ASSET__6b7a6672__"